import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { Pageable } from '../../../models/pageable-mode';
import { AppFilter } from '../../../models/app-filter.model';
import { AbPortaria } from 'app/abstract/full-pages/portaria/portaria.abstract';

@Injectable({ providedIn: 'root' })
export class PortariaService extends AbPortaria implements OnDestroy {

  pageablePessoaUnidade: Pageable = new Pageable();
  filterPessoaUnidade: AppFilter = new AppFilter();
  previsaoVisitaId: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private readonly destroy$ = new Subject();


  public getPrevisaoVisita() {
    return this.get('previsaoVisitas/all/');
  }

  public getAllPrevisaoVisitas(filter: AppFilter) {
    return this.get(`previsaoVisitas/filter/${filter.encode()}`);
  }

  public getRelatorioPrevisaoVisita(filter: AppFilter) {
    const size = filter.size
    filter.size = 2147483647
    const getRelatorio = this.get(`previsaoVisitas/relatorio/filter/${filter.encode()}`);
    filter.size = size
    return getRelatorio;
  }

  public getAllPrevisoesPortaria(filter: AppFilter) {
    return this.get(`previsaoVisitas/portaria/filter/${filter.encode()}`);
  }

  public getAllPrevisoesPortariaAgenda(filter: AppFilter) {
    return this.get(`previsaoVisitas/portaria/agenda/filter/${filter.encode()}`);
  }

  public desativarPrevisaoVisita(id: number) {
    return this.delete("previsaoVisitas/desativar/", id);
  }

  getPessoaUnidade() {
    this.getAllPrevisaoVisitas(new AppFilter())
      .pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
        this.pageablePessoaUnidade = data
      });
  }

  getVisitantesUnidadeByNome(filter: AppFilter) {
    return this.get(`api/v1/visitantes/${filter.encode()}`)
  }

  registrarEntrada(portaria: any) {
    return this.save("portarias/registrar_entrada", portaria);
  }

  getAllVisitantes(filter: AppFilter) {
    return this.get(`previsaoVisitas/visitante/all/filter/${filter.encode()}`)
  }

  findVisitanteByCurrentPessoaUnidadeAndDocumentoWhenNotInUnidade(documento, unidadeId) {
    return this.get(`previsaoVisitas/visitante/by_documento_when_not_in_unidade/${documento}/${unidadeId}`)
  }

  registrarSaida(entity) {
    return this.save("portarias/registrar_saida/", entity);
  }

  getVisitanteById(id) {
    return this.get(`previsaoVisitas/visitante/${id}`);
  }

  getPrevisaoVisitaById(id) {
    return this.get(`previsaoVisitas/${id}`);
  }

  getPrevisaoVisitaQRCode(id, deviceId, fingerPrint) {
    return this.get(`public/qrcode/${id}/${deviceId}/${fingerPrint}`);
  }

  getVisitantePreCadastroConviteById(id, deviceId, fingerPrint) {
    return this.get(`public/convite/${id}/${deviceId}/${fingerPrint}`);
  }

  findVisitanteByDocumento(documento) {
    return this.get(`public/convite/visitante_conta_integrador/${documento}`)
  }

  saveVisitante(visitante) {
    return this.save(`public/convite/`, visitante)
  }


  getPrevisaoVisitaAbrirPortaQRCode(json) {
    return this.post('public/qrcode/abrir_porta', json);
  }

  getPrevisaoVisitaAbrirPortaKey(json) {
    return this.post('public/qrcode/abrir_porta', json);
  }

  getVisitanteListaConvidados(id) {
    return this.get(`public/visitanteListaConvidados/${id}`);
  }

  getVisitantePreCadastro(id) {
    return this.get(`public/visitante_pre_cadastro/${id}`);
  }

  salvarConvidado(id, convidado) {
    return this.save(`public/visitanteListaConvidados/${id}/convidado/`, convidado);
  }

  findByPortariaVisitanteId(id: number) {
    return this.get(`portarias/visitanteId/${id}`);
  }

  getVisitanteByPortariaId(id) {
    return this.get(`portarias/${id}/visitante`);
  }

  salvarPrevisaoVisita(entity) {
    return this.save("previsaoVisitas/", entity);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
